import Vue from 'vue'
import Parse from 'parse'

const ParsePlugin = {
    install(Vue) {
        Parse.initialize(process.env.VUE_APP_HORGANICE_PARSE_APP_ID)
        Parse.serverURL = process.env.VUE_APP_HORGANICE_PARSE_SERVER_URL
        Vue.prototype.Parse = Parse
    }
}
Vue.use(ParsePlugin)